export enum CXEnvironments {
    Production = 'production',
    Staging = 'staging',
    Development = 'development'
}

export interface ICXEnvironment {
    prefix: string;
    domain: string;
    awsBucket: string;
    environment: CXEnvironments;
}

export type TCXDomains =
    | 'hbportal.co'
    | 'hb-site-dev.com'
    | 'localhost'
    | 'lvh.me'
    | string;
